import { Localized, useLocalization } from '@fluent/react';
import { Textarea } from '@vechaiui/react';
import { useEffect } from 'react';
import { useField } from 'formik';

import { CountryComboboxFormik } from '#/components/controls/CountryCombobox';
import { InputFormik } from '#/components/controls/Input';
import { MalaysiaCityComboboxFormik } from '../controls/MalaysiaCityCombobox';
import { MalaysiaStateComboboxFormik } from '#/components/controls/MalaysiaStateCombobox';
import { STATE_LIST } from '#/constants/malaysia-state-list';
import { formatTextUppercase } from '#/utils/formatter';

const PostalAddressForm: React.FC<PostalAddressFormProps> = ({ name }) => {
  const namePrefix = name ? `${name}.` : '';
  const { l10n } = useLocalization();
  const [addressRegionField] = useField(`${namePrefix}addressRegion`); // selected state
  const [, , addressLocalityHelper] = useField(`${namePrefix}addressLocality`);

  // Resets locality when region changed.
  useEffect(() => {
    addressLocalityHelper.setValue('');
  }, [addressRegionField.value]);

  return (
    <div className="space-y-2">
      <div>
        <Localized id="street-address" attrs={{ placeholder: true }}>
          <InputFormik
            as={Textarea}
            label={l10n.getString('street-address')}
            name={`${namePrefix}streetAddress`}
          />
        </Localized>
      </div>

      <div className="grid md:grid-cols-2 gap-2 md:gap-4">
        <div>
          <Localized id="address-region" attrs={{ placeholder: true }}>
            <MalaysiaStateComboboxFormik
              label={l10n.getString('address-region')}
              name={`${namePrefix}addressRegion`}
            />
          </Localized>
        </div>
        <div>
          <Localized id="address-locality" attrs={{ placeholder: true }}>
            {STATE_LIST[STATE_LIST.findIndex((x) => x.code === addressRegionField.value)]
              ?.cities ? (
              <MalaysiaCityComboboxFormik
                disabled={!addressRegionField.value}
                label={l10n.getString('address-locality')}
                name={`${namePrefix}addressLocality`}
                state={addressRegionField.value}
              />
            ) : (
              <InputFormik
                formatter={formatTextUppercase}
                disabled={!addressRegionField.value}
                label={l10n.getString('address-locality')}
                name={`${namePrefix}addressLocality`}
              />
            )}
          </Localized>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-2 md:gap-4">
        <div>
          <Localized id="postal-code" attrs={{ placeholder: true }}>
            <InputFormik label={l10n.getString('postal-code')} name={`${namePrefix}postalCode`} />
          </Localized>
        </div>

        <div>
          <Localized id="address-country" attrs={{ placeholder: true }}>
            {/* TODO: remove readonly! */}
            <CountryComboboxFormik
              readOnly
              label={l10n.getString('address-country')}
              name={`${namePrefix}addressCountry`}
            />
          </Localized>
        </div>
      </div>
    </div>
  );
};
export type PostalAddressFormProps = {
  name?: string;
};

export default PostalAddressForm;
